import { SecurityTokenRequest } from '../api/securitytoken/securitytokenrequest';
import { SecurityTokenResponse, SecurityTokenResponseDtoImpl } from '../api/securitytoken/securitytokenresponse';
import { APIFeatures } from '../util/apifeatures';
import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { StatusCodes } from '../util/statuscodes';
import { APIProcessorImpl } from './apiProcessor';
import { Strings } from '../../utils/resources/strings';

export class SecurityTokenAPIProcessorImpl extends APIProcessorImpl<SecurityTokenRequest, SecurityTokenResponse>
{

      execute(request: SecurityTokenRequest): void
    {
        super.execute(request);
    }  
     /*  execute()
     {
         console.log("execute() in SecurityTokenAPIProcessorImpl"); 

         let securityTokenResponse = new SecurityTokenResponseDtoImpl(APIFeatures.SECURITY_TOKEN, "Security Token generated");
         securityTokenResponse.setSecurityCounter("590ddf67-b669-46b3-9e00-86f5442e5f11");
         
         this.getAPISuccess(securityTokenResponse);
        }  */
        
        onSuccess(responseMapper: ResponseMapper): void 
        {
            super.onSuccess(responseMapper);
            try{
                
                if(+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
                {
                    let response = new SecurityTokenResponseDtoImpl(APIFeatures.SECURITY_TOKEN , "Security Token generated");
                    response.setSecurityCounter(responseMapper.getResponseMap().securityCounter);
                    //response.setSecurityCounter("89239721-2128-4908-b536-5cc69413b210");

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new SecurityTokenResponseDtoImpl(APIFeatures.SECURITY_TOKEN, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new SecurityTokenResponseDtoImpl(APIFeatures.SECURITY_TOKEN, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch(e)
        {
            this.getAPIFailure(new SecurityTokenResponseDtoImpl(APIFeatures.SECURITY_TOKEN, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
   
       
                this.getAPIFailure(new SecurityTokenResponseDtoImpl(APIFeatures.SECURITY_TOKEN, responseMapper.getStatusMsg()));
            
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/securitytokenapiprocessor.tsx